<template>
<div>
  <div class="survey">
    <h2>剩餘日數: {{ update['hp'] }}</h2>
    <h3>現在擁有稱號:</h3>
    <p v-if="!update['v1'] && !update['v2'] && !update['v3'] && !update['v4'] && !update['v5']">暫無</p>
    <p v-if="update['v1']">「重視工作」</p>
    <p v-if="update['v2']">「重視與異性關係」</p>
    <p v-if="update['v3']">「好奇心」</p>
    <p v-if="update['v4']">「重視團隊精神」</p>
    <p v-if="update['v5']">「願了解別人」</p>
    <h3>現在擁有能力/技巧/態度/知識:</h3>
    <p v-if="!update['a1'] && !update['a2'] && !update['a3'] && !update['k1'] && !update['k2'] && !update['s1'] && !update['s2'] && !update['s3'] && !update['s4'] && !update['s5'] && !update['s6'] && !update['s7']">暫無</p>
    <p v-if="update['a1']">對新事物持開放態度</p>
    <p v-if="update['a2']">抵抗逆境態度</p>
    <p v-if="update['a3']">熱愛表演態度</p>
    <p v-if="update['s1']">整理個人履歷技能</p>
    <p v-if="update['s2']">思考分析技能</p>
    <p v-if="update['s3']">駕駛技能</p>
    <p v-if="update['s4']">魔術教學能力技能</p>
    <p v-if="update['s5']">攝影及後期製作技能</p>
    <p v-if="update['s6']">照顧病患技能</p>
    <p v-if="update['s7']">健身技能</p>
    <p v-if="update['k1']">管理社交媒體知識</p>
    <p v-if="update['k2']">編劇知識</p>
  </div>
</div>
</template>

<script>
import { db } from '../main';

export default {
  name: 'Situation',
  data() {
    return {
      update: {},
    }
  },
  firestore() {
    return {
      update: db.collection("situation").doc("vGXm16O3cvhXrxKs5bVI"),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 10px 0;
}

.results > ul {
  list-style-type: circle;
}

li {
  padding: 3px;
}

.intro {
  padding: 10px;
}

p {
  padding: 3px;
}

h3 {
  padding: 3px;
}

button {
  margin: 5px auto;
  padding: 2px;
}

.question {
  padding: 5px 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.description {
  display: flex;
  padding: 3px;
}

.submit {
  padding: 20px 0;
  text-align: center;
}

hr {
  width: 30%;
  text-align: center; 
  margin: 8px auto;
}

@media screen and (min-width: 1024px) {
  .question {
    padding: 5px 30%;
  }
  hr {
    width: 50%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Situation.vue